<template>
  <div class="error-page">
    <div class="error-container">
      <div class="error-icon">
        <i class="ri-lock-line"></i>
      </div>
      <h1 class="error-code">403</h1>
      <h2 class="error-title">沒有權限</h2>
      <p class="error-message">
        抱歉，您沒有權限訪問此頁面。
      </p>
      <p class="error-description">
        如需訪問此功能，請聯絡系統管理員分配相應權限。
      </p>
      <div class="error-actions">
        <button class="btn btn-primary" @click="goBack">
          <i class="ri-arrow-left-line"></i>
          返回上一頁
        </button>
        <button class="btn btn-secondary" @click="goHome">
          <i class="ri-home-line"></i>
          返回首頁
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import authService from '@/helpers/authservice/authService.js';

export default {
  name: 'Forbidden',
  setup() {
    const router = useRouter();

    const goBack = () => {
      router.back();
    };

    const goHome = () => {
      const accountType = authService.getAccountType();
      
      if (accountType === 'system') {
        router.push('/system/dashboard');
      } else if (accountType === 'platform') {
        router.push('/platform/dashboard');
      } else if (accountType === 'client') {
        router.push('/client/dashboard');
      } else {
        router.push('/system/login');
      }
    };

    return {
      goBack,
      goHome,
    };
  },
};
</script>

<style scoped>
.error-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.error-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  padding: 60px 40px;
  text-align: center;
  max-width: 500px;
  width: 100%;
}

.error-icon {
  margin-bottom: 24px;
}

.error-icon i {
  font-size: 120px;
  color: #f5a623;
  animation: shake 0.5s ease-in-out;
}

@keyframes shake {
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(-10deg); }
  75% { transform: rotate(10deg); }
}

.error-code {
  font-size: 72px;
  font-weight: 700;
  color: #333;
  margin: 0 0 16px 0;
  line-height: 1;
}

.error-title {
  font-size: 32px;
  font-weight: 600;
  color: #333;
  margin: 0 0 16px 0;
}

.error-message {
  font-size: 18px;
  color: #666;
  margin: 0 0 12px 0;
}

.error-description {
  font-size: 14px;
  color: #999;
  margin: 0 0 32px 0;
}

.error-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  text-decoration: none;
}

.btn i {
  font-size: 18px;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-secondary {
  background: #f5f5f5;
  color: #333;
}

.btn-secondary:hover {
  background: #e0e0e0;
}

@media (max-width: 768px) {
  .error-container {
    padding: 40px 24px;
  }

  .error-icon i {
    font-size: 80px;
  }

  .error-code {
    font-size: 56px;
  }

  .error-title {
    font-size: 24px;
  }

  .error-message {
    font-size: 16px;
  }

  .error-actions {
    flex-direction: column;
  }

  .btn {
    width: 100%;
    justify-content: center;
  }
}
</style>
